export * from './QRCode';
export { default as QRCode } from './QRCode';
